module.exports = __webpack_public_path__ + "img/title_pc.ae2a73d2.svg";